import { PickerColumn } from "react-vant";



export const positionTypeList: any = [
  {
    text: '户内',
    value: '户内',
  },
  {
    text: '工区',
    value: '工区',
  },
  {
    text: '其他',
    value: '其他',
  },
];


export const ugentTypeList: any = [
  {
    text: '紧急',
    value: 'urgent',
  },
  {
    text: '特急',
    value: 'critical',
  },
  {
    text: '一般',
    value: 'normal',
  },
];
